/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkReportCreateRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkReportCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkReportCreateRequest>): WellArchitectedFrameworkReportCreateRequest {
        let obj = Object.assign(new WellArchitectedFrameworkReportCreateRequest(), model);
        WellArchitectedFrameworkReportCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkReportCreateRequest>): WellArchitectedFrameworkReportCreateRequest {
        if (!model) return null;
        return WellArchitectedFrameworkReportCreateRequest.newInstance(<WellArchitectedFrameworkReportCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkReportCreateRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkReportCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkReportCreateRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkReportCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.report_configuration) {
            models.ReportConfigurationForAssessmentRun.fixupPrototype(this.report_configuration);
        }
    }

    /**
     * Report configuration to generate report
     */
    report_configuration: models.ReportConfigurationForAssessmentRun;

}
